@if (title) {
<div class="modal-header">
  <neo-tooltip
    [text]="title"
    placement="top auto"
    container="body">
    <div class="modal-header-title">{{ title }}</div>
  </neo-tooltip>
</div>
}

<div class="modal-body">
  @if (description) {
  <div class="description">{{ description }}</div>
  } @if (descriptionHtml) {
  <div class="froala-readonly-container" [froalaView]="descriptionHtml | migrateQuill"></div>
  }
</div>

<div class="modal-footer">
  <div class="buttons-box">
    <button type="button" aut-id="close-button" class="fto-legacy-btn btn btn-default" (click)="close()">Close</button>
  </div>
</div>
